import { render, staticRenderFns } from "./kmodal.vue?vue&type=template&id=a2030858&scoped=true&"
import script from "./kmodal.vue?vue&type=script&lang=js&"
export * from "./kmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2030858",
  null
  
)

export default component.exports